<template>
  <v-row class="justify-center">
    <v-col cols="12" lg="5" xl="6" class="d-flex align-center">
      <v-container>
        <div class="pa-7 pa-sm-12">
          <v-row class="justify-center">
            <v-col cols="12" lg="9" xl="6">
              <img src="@/assets/logo.png" width="80" />
              <h2 class="font-weight-bold mt-4 blue-grey--text text--darken-2">{{ $t('sign_in') }}</h2>
              <v-form ref="form" v-model="valid" lazy-validation @submit="submit">
                <v-text-field v-model="username" :rules="usernameRules" :label="$t('username_or_email')" class="mt-4"
                  required outlined>
                </v-text-field>
                <v-text-field v-model="password" :rules="passwordRules" :label="$t('password')" required outlined
                  @click:append="showPassword = !showPassword" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'">
                </v-text-field>
                <v-btn type="submit" :disabled="!valid || isLoading" :loading="isLoading" color="primary" block
                  class="mr-4" submit @click="submit">{{ $t('sign_in') }}</v-btn>
              </v-form>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  name: "FullLogin",
  data: () => ({
    isLoading: false,
    valid: true,
    password: "",
    showPassword: false,
    passwordRules: [
      v => !!v || "Password is required"
    ],
    username: "",
    usernameRules: [
      v => !!v || "Username is required"
    ],
    checkbox: false
  }),
  methods: {
    async submit(e) {
      e.preventDefault()
      this.isLoading = true
      this.$refs.form.validate();
      try {
        const form = new FormData();
        form.append('username', this.username)
        form.append('password', this.password)
        const { data } = await this.$axios.auth.login(form)
        console.log(data)
        Cookies.set('token', data)
        this.isLoading = false
        this.$axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
        window.location.reload()
        // this.$router.push({ path: "/dashboard" })
      } catch (error) {
        this.isLoading = false
        console.log(this.$axios)
      }
      // if (this.$refs.form.validate(true)) {
      //   this.$router.push({ path: "/dashboards/analytical" });
      // }
    }
  },

};
</script>
